'use client';
import { useEffect } from 'react';
import { logError } from '@/lib/errorLogger';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    logError({
      message:  error?.message ?? 'Global Next.js crash',
      stack:    error?.stack,
      source:   'global-error',
      method:   'GlobalError boundary',
    });
  }, [error]);

  return (
    <html>
      <body style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif', background: '#0f0f0f', color: '#ccc' }}>
        <h2 style={{ marginBottom: '1rem' }}>Something went wrong</h2>
        <p style={{ marginBottom: '1.5rem', color: '#888' }}>Our team has been notified. Please try again.</p>
        <button
          onClick={reset}
          style={{ padding: '0.5rem 1.5rem', background: '#333', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
